<template>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>新增行业类型</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            
            <v-text-field
              v-model="formData.name"
              label="类型名称"
              :rules="[v => !!v || '请输入类型名称']"
              required
            ></v-text-field>

            <!-- 新增地区类型单选组 -->
            <v-radio-group 
              v-model="formData.domestic"
              label="地区类型"
              :rules="[v => !!v || '请选择地区类型']"
              mandatory
            >
              <v-radio
                label="内地"
                value="true"
              ></v-radio>
              <v-radio
                label="海外"
                value="false"
              ></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">取消</v-btn>
          <v-btn color="blue darken-1" text @click="submit">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
import { typesApi } from '@/api/types'
  
  export default {
    name: 'CreateIndustryTypePopup',
    data() {
      return {
        dialog: false,
        valid: false,
        formData: {
          name: '',
          domestic: false,
        },
      }
    },
    methods: {
      open() {
        this.dialog = true
      },
      close() {
        this.dialog = false
        this.$refs.form.reset()
      },
      async submit() {
        if (!this.$refs.form.validate()) return
        
        try {
          await typesApi.createIndustryType({
                "name": this.formData.name,
                "domestic": this.formData.domestic
            });
          this.$emit('type-created');
          this.close();
          this.$toast.success('创建成功')
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('创建失败：' + errorMessage);
        }
      }
    }
  }
  </script> 